import { FC } from "react";
import { Text } from "@chakra-ui/react";
import {
  PRIVACY_POLICY_URL,
  sharedProps,
  TERMS_OF_SERVICE_URL,
} from "~/constants";
import { Checkbox } from "~/OnboardingApp/components";
import { trackEmail as track } from "~/OnboardingApp/events";
import { Trans } from "~/utils/i18next";

const components = {
  PrivacyPolicyLink: (
    <Text
      as="a"
      color="inherit"
      href={PRIVACY_POLICY_URL}
      onClick={track.privacyLink}
      px={0}
      target="_blank"
      {...sharedProps.link.hover}
    />
  ),
  TermsLink: (
    <Text
      as="a"
      color="inherit"
      href={TERMS_OF_SERVICE_URL}
      onClick={track.termsLink}
      px={0}
      target="_blank"
      {...sharedProps.link.hover}
    />
  ),
};

export const TermsCheckbox: FC = () => {
  return (
    <Checkbox name="acceptedTerms">
      <Text color="th.gray4" variant="small-print">
        <Trans
          components={components}
          i18nKey="onboarding.emailPage.acceptedTerms"
        />
      </Text>
    </Checkbox>
  );
};
